import { Component, Input } from '@angular/core';
@Component({
  selector: 'app-rt-trans',
  templateUrl: './rt-trans.component.html',
  styleUrl: './rt-trans.component.css'
})
export class RtTransComponent {
  @Input() rateInfo: any;
  @Input() showTrucking: boolean = true;
  // the "+" on smaller screens: show the whole route (hidden legs + full port names) instead of the short line
  expanded = false;

  toggleExpanded(event: Event) {
    event.stopPropagation();
    this.expanded = !this.expanded;
  }
}
